import { useState } from 'react';
import { Box } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

const UserCardActionsPanel = ({ actions = {} }) => {
  const [isActive, setIsActive] = useState(false);
  const { isMobile } = useDeviceStore();
  const { defaultAction = [], mobileAction = {} } = actions;
  const { cb: mobileCb } = mobileAction;
  const toggleSettings = () => setIsActive(!isActive);

  return (
    <Box className={styles.iconContainer}>
      {isMobile ? (
        <Icon
          className={styles.icon}
          name="icons/general/state/setting"
          size="m"
          color="accent_color_2"
          onClick={mobileCb || toggleSettings}
        />
      ) : (
        defaultAction.map(({ actionType, cb }) => (
          <Icon
            key={`${actionType}-action`}
            className={styles.icon}
            name={`icons/general/action/${actionType}`}
            size="m"
            color="accent_color_2"
            onClick={cb || toggleSettings}
          />
        ))
      )}
    </Box>
  );
};

export default UserCardActionsPanel;
